import React, {
    FC,
    useState,
} from "react";
import {
    AppBar,
    Button,
    Drawer,
    IconButton,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {Menu as MenuIcon} from "@mui/icons-material";
import {MenuItem} from "./MenuItem";
import {menuConfig} from "../components/menuConfig";
import {
    useLocation,
    useNavigate,
} from "react-router-dom";

export const HeaderMenu: FC = () => {
    const theme = useTheme();
    const [openDrawer, setOpenDrawer] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const toggleDrawer = (open: boolean) => {
        setOpenDrawer(open);
    };

    return (
        <>
            <AppBar
                position="static"
                sx={{
                    boxShadow: "none",
                    backgroundColor: "transparent",
                    color: theme.palette.menuInactive.text,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: isSmallScreen? 0:"8px 16px",
                }}
            >
                {isSmallScreen && (
                    <IconButton
                        color="inherit"
                        aria-label="open menu"
                        onClick={() => toggleDrawer(true)}
                        sx={{padding: 0}}
                    >
                        <MenuIcon/>
                    </IconButton>
                )}
                {!isSmallScreen && (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                        }}
                    >
                        {menuConfig.map((menu, index) => (
                            <MenuItem
                                key={index}
                                localeId={menu.localeId}
                                redirectUrl={menu.redirectUrl}
                            />
                        ))}
                    </div>
                )}
            </AppBar>
            <Drawer
                anchor="left"
                open={openDrawer}
                onClose={() => toggleDrawer(false)}
                sx={{
                    display: {xs: "block", sm: "block", md: "none"},
                }}
            >
                <div
                    style={{
                        width: 250,
                        padding: 16,
                    }}
                >
                    {menuConfig.map((menu, index) => (
                        <Button
                            key={index}
                            onClick={() => {
                                console.log("Navigating to:", menu.redirectUrl);
                                navigate(menu.redirectUrl);
                                toggleDrawer(false);
                            }}
                            fullWidth
                            sx={{
                                textAlign: "left",
                                padding: "12px 16px",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                color: location.pathname === menu.redirectUrl
                                    ? theme.palette.menuActive.text
                                    : theme.palette.menuInactive.text,
                                backgroundColor: location.pathname === menu.redirectUrl
                                    ? theme.palette.menuActive.main
                                    : theme.palette.menuInactive.main,
                                "&:hover": {
                                    backgroundColor: theme.palette.menuActive.main,
                                    color: theme.palette.menuActive.text,
                                },
                            }}
                        >
                            <MenuItem localeId={menu.localeId} redirectUrl={menu.redirectUrl}/>
                        </Button>
                    ))}
                </div>
            </Drawer>
        </>
    );
};
